/**
 * Maps a signup proxy HTTP status (+ the backend `errorKey`) to a
 * `publicEventSignup` i18n key. Shared by the adult and child details steps so
 * the user-facing copy stays consistent.
 *
 * "Full" and "duplicate" are BOTH 409 in the final contract, disambiguated by
 * the body `errorKey` (`publicEventFull` / `publicEventDuplicate`).
 */
const REJECTION_KEYS: Record<string, string> = {
  age_tooYoung: "signupErrorTooYoung",
  age_tooOld: "signupErrorTooOld",
  age_unknown: "signupErrorDobMissing",
  age_invalid: "signupErrorDobMissing",
  attendeeTypeNotAllowed: "signupErrorAttendeeNotAllowed",
  dateOfBirthRequired: "signupErrorDobRequired",
  // Core turned the guardian number down; the remedy is the same whether it was
  // missing or unparseable, so both land on the field's own copy.
  guardianPhoneInvalid: "phoneInvalid",
};

export function signupErrorKey(status: number, errorKey?: string): string {
  if (status === 410) return "signupErrorGone";
  if (status === 409) {
    return errorKey === "publicEventFull"
      ? "signupErrorFull"
      : "signupErrorDuplicate";
  }
  if (status === 422 && errorKey) {
    return REJECTION_KEYS[errorKey] ?? "signupErrorGeneric";
  }
  return "signupErrorGeneric";
}
